import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
};

const normalize = (v) => Number(v);

const findIndex = (state, productId, categoryId) =>
  state.items.findIndex(
    (i) =>
      normalize(i.productId) === normalize(productId) &&
      normalize(i.categoryId) === normalize(categoryId)
  );

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    setCart: (state, action) => {
      state.items = Array.isArray(action.payload) ? action.payload : [];
    },

    // ================= ADD =================
    addItem: (state, action) => {
      const item = action.payload;

      const index = findIndex(state, item.productId, item.categoryId);

      // PACKAGE (single entry)
      if (normalize(item.categoryId) === 3) {
        if (index !== -1) return;

        state.items.push({
          ...item,
          quantity: 1,
          TotalPrice: item.price,
        });

        return;
      }

      // NORMAL ITEM
      if (index !== -1) {
        const existing = state.items[index];

        existing.quantity += item.quantity || 1;
        existing.TotalPrice = existing.quantity * existing.price;
      } else {
        state.items.push({
          ...item,
          quantity: item.quantity || 1,
          TotalPrice: item.price * (item.quantity || 1),
        });
      }
    },

    // ================= REMOVE =================
    removeItem: (state, action) => {
      const { productId, categoryId, quantity = 1 } = action.payload;

      const index = findIndex(state, productId, categoryId);

      if (index === -1) return;

      const existing = state.items[index];

      // PACKAGE REMOVE (SAFE DELETE)
      if (normalize(categoryId) === 3) {
        state.items.splice(index, 1);
        return;
      }

      // NORMAL ITEM REMOVE
      const newQty = existing.quantity - quantity;

      if (newQty <= 0) {
        state.items.splice(index, 1);
      } else {
        existing.quantity = newQty;
        existing.TotalPrice = newQty * existing.price;
      }
    },

    clearCart: (state) => {
      state.items = [];
    },
  },
});

export const { addItem, removeItem, setCart, clearCart } = cartSlice.actions;
export default cartSlice.reducer;